<template>
  <Modal
    :id="'cpm-add-invoice-modal'"
    :loadingFlag="loading || formLoading"
    @cancelled="onCancel"
  >
    <template slot="header">
      {{ $t("invoices") }} {{ $t("advanced_search") }}
    </template>

    <template slot="body">
      <div class="form-group">
        <Dropdown
          :options="advancedSearchData.invoice_statusTV || []"
          :id="'label_id'"
          class="m2"
          :selected="
            advancedSearchData.invoice_statusTV.filter((e) =>
              (status_textkeys || '').split(',').includes(e.value)
            )
          "
          :placeholder="$t('status')"
          @selectedChange="
            (e) => onMultipleDropdownChange('status_textkeys', e)
          "
          box
          deselect
          multiple
          allnone
          :listHeight="300"
        ></Dropdown>
        <Dropdown
          :options="advancedSearchData.invoice_projectsTV || []"
          :id="'label_id'"
          class="m2"
          :selected="
            advancedSearchData.invoice_projectsTV.filter((e) =>
              (invoice_project_ids || '').split(',').includes(`${e.value}`)
            )
          "
          :placeholder="$t('invoice_project')"
          @selectedChange="
            (e) => onMultipleDropdownChange('invoice_project_ids', e)
          "
          box
          deselect
          multiple
          allnone
          :listHeight="250"
        ></Dropdown>
        <TextField
          class="m1"
          :id="'recipient'"
          v-bind="textFieldConfig"
          :value="recipient"
          :placeholder="$t('recipient')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
        <TextField
          class="m1"
          :id="'subject'"
          v-bind="textFieldConfig"
          :value="subject"
          :placeholder="$t('subject')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
        <TextField
          class="m1"
          :id="'invoice_ref'"
          v-bind="textFieldConfig"
          :value="invoice_ref"
          :placeholder="$t('invoice_ref')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
        <TextField
          class="m1"
          :id="'amount'"
          v-bind="textFieldConfig"
          :value="amount"
          :placeholder="$t('amount')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
        <!-- <div class="checkbox-container">
          <div class="dt-checkbox-control">
            <div class="dt-checkbox v2">
              <input
                type="checkbox"
                name="pdf"
                :id="'pdf'"
                :checked="pdf == 1"
                @change="(e) => onCheckboxChange('pdf', e)"
              />
              <div class="checkmark"></div>
            </div>
            <div class="dt-checkbox-label">{{ $t("pdf") }}</div>
          </div>
        </div> -->
        <div class="ut-flex" style="gap: 10px">
          <TextField
            style="flex: 1"
            class="m1"
            :type="'date'"
            :id="'start'"
            v-bind="textFieldConfig"
            :value="start"
            :placeholder="`${$t('invoice')} ${$t('start')}`"
            @valuechanged="onTextFieldValueChange"
          />
          <TextField
            style="flex: 1"
            class="m1"
            :type="'date'"
            :id="'end'"
            v-bind="textFieldConfig"
            :value="end"
            :placeholder="`${$t('invoice')} ${$t('end')}`"
            @valuechanged="onTextFieldValueChange"
          />
        </div>
        <div class="ut-flex" style="gap: 10px">
          <TextField
            style="flex: 1"
            class="m1"
            :type="'date'"
            :id="'start_payment'"
            v-bind="textFieldConfig"
            :value="start_payment"
            :placeholder="`${$t('payment')} ${$t('start')}`"
            @valuechanged="onTextFieldValueChange"
          />
          <TextField
            style="flex: 1"
            class="m1"
            :type="'date'"
            :id="'end_payment'"
            v-bind="textFieldConfig"
            :value="end_payment"
            :placeholder="`${$t('payment')} ${$t('end')}`"
            @valuechanged="onTextFieldValueChange"
          />
        </div>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $t("cancel") }}
      </button>
      <button
        class="dt-button s6 v1"
        :disabled="loading || searchFilter.no_filter_selected"
        :class="{
          disabled: loading || searchFilter.no_filter_selected,
        }"
        @click.stop="searchClick"
      >
        {{ $t("search") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import {
  ensureBoolIntObjectFromKeys,
  ensureStringObjectFromKeys,
} from "../../../../utility/fp";
import { createAdvancedSearchConfig } from "../../../../dt-plugins/advanced-search/advanced-search.model";
import { isEmpty } from "ramda";
import { createAdvancedSearchModal } from "../../../../dt-plugins/advanced-search/advance-search.mixin";

export const invoiceListAdvancedSearchConfig = createAdvancedSearchConfig({
  searchConfigStringKeys: [
    "start",
    "end",
    "start_payment",
    "end_payment",
    "subject",
    "amount",
    "invoice_ref",
    "recipient",
    "invoice_project_ids",
    "status_textkeys",
  ],
  searchConfigMulTVMap: [
    ["invoice_project_ids", "invoice_projectsTV"],
    ["status_textkeys", "invoice_statusTV"],
  ],
  // booleanSearchKeyLabelMap: {
  //   pdf: "PDF",
  // },
});

export default {
  components: {
    Modal,
  },
  props: {
    loading: {
      type: Boolean,
    },
    advancedSearchData: {
      type: Object,
    },
    initSearchFilter: {
      required: true,
      type: Object,
    },
  },
  mixins: [createAdvancedSearchModal(invoiceListAdvancedSearchConfig)],
  data: function () {
    return {
      start: "",
      end: "",
      start_payment: "",
      end_payment: "",
      status_textkeys: "",
      invoice_project_ids: "",
      subject: "",
      amount: "",
      // pdf: "",
      invoice_ref: "",
      recipient: "",

      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
      },
      // invoice_statuses: [],
      // invoice_project_ids: [],

      recipient: "",
      subject: "",
      invoice_no: "",
      amount: "",
      invoice_start_date: "",
      invoice_end_date: "",
      payment_start_date: "",
      payment_end_date: "",
      start_from: 0,

      formLoading: false,
    };
  },
  mounted: function () {
    // console.log("WERE", this.labels, this.labelsTV);
  },
  computed: {
    searchFilter: function () {
      const no_filter_selected =
        invoiceListAdvancedSearchConfig.advancedSearchConfigKeys.every(
          (e) => !this[e]
        );

      // console.log({
        // "advanced-search.vue:247 no_filter_selected": no_filter_selected,
      // });
      return {
        ...ensureStringObjectFromKeys(
          this,
          invoiceListAdvancedSearchConfig.searchConfigStringKeys
        ),
        ...ensureBoolIntObjectFromKeys(
          this,
          invoiceListAdvancedSearchConfig.booleanSearchKeys
        ),
        no_filter_selected,
      };
    },
  },
  methods: {
    onDateChange: function (name, value) {
      // console.log(name, value);
      this[name] = value;
    },
    onTextFieldValueChange: function (key, value) {
      this[key] = value;
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    searchClick: async function (e) {
      // this.formLoading = true;
      // console.log({
        // "advanced-search.vue:314 this.searchFilter": this.searchFilter,
      // });
      // console.log(
        // this.status_textkeys,
        // this.invoice_project_ids,
        // this.textFieldConfig
      // );
      this.$emit("search", this.searchFilter);
    },
    onDropdownChange: function (name, value) {
      this[name] = value.value;
    },
    onMultipleDropdownChange(name, value) {
      if (!isEmpty(value)) {
        this[name] = value?.map((e) => e.value).join(",") || "";
      } else {
        this[name] = "";
      }
      // console.log({ name, "this[name]": this[name], value });
    },
    onCheckboxChange: function (name, event) {
      this[name] = event.target.checked;
    },

    //MARK: Methods
  },
};
</script>

<style lang="scss">
.checkbox-container {
  .dt-checkbox-control {
    align-items: center;
    .dt-checkbox-label {
      flex: 1;
      padding-left: 10px;
    }
  }
}
</style>
